import React from 'react';
import {Stack, Typography, Button} from '@mui/material';
import useAuthState from 'hooks/useAuthState';
import {useCountdown} from 'hooks/useCountdown';
import {useTranslate} from 'hooks/useTranslate';

const LOGOUT_DELAY_SECONDS = 30;

const LoginDemoMainPage: React.FC = () => {
  const {signOut, refresh} = useAuthState();
  const t = useTranslate();

  const {seconds, reset} = useCountdown(LOGOUT_DELAY_SECONDS, () => {
    signOut.mutate();
  });

  const handleRefresh = async () => {
    try {
      await refresh?.();
      reset(LOGOUT_DELAY_SECONDS);
    } catch (e) {
      console.error(e);
    }
  };

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return (
    <Stack
      id={'main-page-root'}
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: theme.palette.grey['50'],
      })}>
      <Stack id={'main-page'} flex={1} direction={'column'}>
        <Stack
          id={'main-content'}
          flex={1}
          sx={(theme) => ({
            background: theme.palette.grey['50'],
            flex: 1,
            position: 'relative',
            overflowY: 'hidden',
            height: '100vh',
            backgroundColor: theme.palette.background.default,
            maxWidth: 'calc(100vw - 4px)',
            [theme.breakpoints.up('lg')]: {
              maxWidth: 'calc(100vw - 280px - 4px)',
            },
            [theme.breakpoints.down('lg')]: {
              pb: 12,
            },
          })}>
          <Typography variant="h5" align="center" sx={{mt: 4}}>
            Authentication Successful
          </Typography>
          <Typography align="center">
            {t('auth.refresh.subtitle')} {minutes}:
            {remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}
          </Typography>
          <Button
            onClick={handleRefresh}
            variant="contained"
            sx={{mt: 2, mx: 'auto'}}
            disabled={!refresh}>
            {t('auth.refresh.button')}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export {LoginDemoMainPage};
